"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isShiny = exports.Shiny = void 0;
function isShiny() {
    return !!window.Shiny;
}
exports.isShiny = isShiny;
const Shiny = window.Shiny;
exports.Shiny = Shiny;
